import React, { useState, useEffect, useRef } from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material"; // Assuming MUI for dialogs
import Loader from "assets/images/chat/loader.gif";
import "./styles.scss";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { AutoAwesome, PlayArrow, StopOutlined } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import Excerpt from "components/modals/Excerpt";
import { Snackbar } from "@mui/material";
import { arabicRegex } from "utils/constant";
import { synthesizeSpeech } from "utils/helpers";
import MicrophoneComponent from "components/pages/MicrophoneComponent";


const AskModal = (props) => {
    const { onClose, open, tripId, tripName, trip } = props;
    const containerBody = useRef(null);
    const [isInitial, setIsInitial] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [text, setText] = useState("");
    const [messageList, setMessageList] = useState([]);
    const [isPlaying, setIsPlaying] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [isContextOpen, setIsContextOpen] = useState(false);
    const [context, setContext] = useState();
    const audioRef = useRef(null);
    const typingIntervalRef = useRef(null);
    const controllerRef = useRef(null);
    const microphoneRef = useRef();

    useEffect(() => {
        scrollToBottom();
    }, [messageList, isLoading]);

    const scrollToBottom = () => {
        if (containerBody.current) {
            containerBody.current.scrollTop = containerBody.current.scrollHeight;
        }
    };

    const submitText = async (finalTranscript) => {
        const tempText = finalTranscript ?? text;
        if (isLoading) return;
        if (!tempText.trim()) return;
        microphoneRef.current?.stopListening();
        controllerRef.current?.abort();
        const controller = new AbortController();
        controllerRef.current = controller;
        stopTyping();
        handleCancel();
        setIsInitial(true);
        setIsLoading(true);
        const userMessage = { type: "user", text: tempText };
        const newMessageList = [...messageList, userMessage];
        setMessageList(newMessageList);
        const temp = tempText;
        setText("");
        try {
            const response = await fetch(
                `https://evai.in/batuta/answer?query=${encodeURIComponent(
                    temp + ` Answer as if you are ${trip?.author?.userName}.`
                )}&trip_id=${tripId}`, {
                signal: controller.signal
            }
            );
            const res = await response.json();
            const aiMessage = {
                type: "response",
                text: "",
                question: temp,
                context: res.context,
                id: Date.now().toString(),
            };
            setIsLoading(false);

            setMessageList((prev) => [...prev, aiMessage]);
            simulateTyping(res.answer ?? 'Something went wrong. Please try after some time', () => {
                setIsLoading(false);
            });
            handleSpeak(res.answer ?? 'Something went wrong. Please try after some time', aiMessage.id);
        } catch (error) {
            console.error("Error fetching response:", error);
            setIsLoading(false);
        }

        setText("");
    };


    const handleShareAnswer = (answer) => {
        if (navigator.share) {
            navigator
                .share({ title: "IB.Ai Answer", text: answer })
                .catch((error) => console.error("Error sharing:", error));
        } else {
            alert("Sharing is not supported in your browser.");
        }
    };

    const handleClose = () => {
        microphoneRef.current?.stopListening();
        controllerRef.current?.abort();
        stopTyping();
        handleCancel();
        setIsInitial(false);
        setIsLoading(false);
        setText("");
        setMessageList([]);
        onClose();
    }

    const simulateTyping = (fullText, callback) => {
        let currentText = "";

        typingIntervalRef.current = setInterval(() => {
            if (currentText.length < fullText.length) {
                currentText = fullText.slice(0, currentText.length + 1);
                setMessageList((prev) =>
                    prev.map((msg, i) =>
                        i === prev.length - 1 ? { ...msg, text: currentText } : msg
                    )
                );
            } else {
                clearInterval(typingIntervalRef.current);
                callback?.();
            }
        }, 30);
    };

    const stopTyping = () => {
        if (typingIntervalRef.current) {
            clearInterval(typingIntervalRef.current);
        }
    };

    const handleSpeak = async (text, id) => {
        // Call the callback function
        handleCancel();
        setIsPlaying(id);
        const isArabic = arabicRegex.test(text)
        try {
            const res = await synthesizeSpeech(
                text,
                isArabic ? 'ar-XA-Standard-C' : 'en-GB-Standard-O',
            );
            const audio = new Audio(`data:audio/mp3;base64,${res.audioContent}`);
            audioRef.current = audio;
            audio.onended = () => setIsPlaying(false);
            audio.play();
        } catch (error) {
            console.error('Speech synthesis failed:', error);
        }
    };

    const handleCancel = () => {
        if (audioRef.current) {
            audioRef.current.pause();
            setIsPlaying(false);
        }
    };

    const handleExcerpt = (context) => {
        setContext(context);
        setIsContextOpen(true);
    }

    const handleTranscriptChange = (transcript) => {
        setText(transcript);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                className="__common_model_class_2"
                maxWidth={'100px'}
                fullWidth={true}
                disableEscapeKeyDown
                width="100%"
            >
                <DialogTitle className="__chat_title" id="alert-dialog-title">
                    <div className="__bot_profile">
                        <img className="__bot_profile_image" src={trip?.author?.profilePic} alt="Bot" />
                        <div>
                            {trip?.author?.userName}
                        </div>
                    </div>
                    <button onClick={handleClose} style={{ float: 'right', background: 'none', border: 'none' }}>
                        <CloseIcon />
                    </button>
                </DialogTitle>
                <DialogContent>
                    <div className="___chat_container_wrapper">
                        <div className="__chat_display">
                            <div className="__container_body" ref={containerBody}>
                                {isInitial ? (
                                    messageList.map((item, index) => (
                                        <div
                                            key={index}
                                            className={item.type === "user" ? "___use_resp_set user" : "___use_resp_set"}
                                            style={
                                                item.type === "user"
                                                    ? { justifyContent: "end", flexDirection: "row-reverse", textAlign: "right" }
                                                    : {}
                                            }
                                        >
                                            <div className="___user">
                                                {item.type === "user" ? (
                                                    <AccountCircleIcon style={{ fontSize: '40px' }} />
                                                ) : (
                                                    <img src={trip?.author?.profilePic} alt="EV Logo" />
                                                )}
                                            </div>
                                            <div className="___response">
                                                <h2>{item.type === "user" ? "You" : trip?.author?.userName}</h2>
                                                <p>{item.text}</p>
                                                {item.type === "response" && (
                                                    <div className="___share_wrapper">
                                                        <button className="__share" onClick={() => handleShareAnswer(item.text)}>🔗 Share</button>
                                                        {isPlaying === item.id ? (
                                                            <button className="__share" onClick={handleCancel}>
                                                                <StopOutlined />
                                                            </button>
                                                        ) : (
                                                            <button className="__share" onClick={() => handleSpeak(item.text, item.id)}>
                                                                <PlayArrow />
                                                            </button>
                                                        )}
                                                        <button className="__share" onClick={() => handleExcerpt(item)}>Knowledge Excerpt</button>
                                                        <button
                                                            className="__share"
                                                            onClick={() => {
                                                                navigator.clipboard.writeText(item.plaintext || item.text);
                                                                setSnackbarOpen(true);
                                                                setSnackbarMessage("Copied to clipboard!");
                                                            }}
                                                        >
                                                            📋 Copy
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="__initial_loader">
                                        <img className="__bot_image" src={trip?.author?.profilePic} alt="Bot" />
                                        <span>
                                            Ask <b>{trip?.author?.userName}</b> regarding the trip <b>{tripName}</b>
                                        </span>
                                    </div>
                                )}
                                {isLoading && (
                                    <div className="__loading">
                                        <img src={Loader} alt="Loading" />
                                        Generating Answer...
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="___send_form">
                            <textarea
                                className="___text_area"
                                placeholder="Ask me anything!"
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && submitText(null)}
                            />
                            <div className="__right_btn_actions">
                                <MicrophoneComponent
                                    onTranscriptChange={handleTranscriptChange}
                                    disabled={isLoading}
                                    onAutoSubmit={submitText}
                                    ref={microphoneRef}
                                />
                                <button onClick={() => submitText(null)} disabled={!text.length || isLoading}>
                                    <AutoAwesome /> Ask
                                </button>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={() => setSnackbarOpen(false)}
                    message={snackbarMessage}
                />
            </Dialog>
            <Excerpt
                open={isContextOpen}
                onClose={() => setIsContextOpen(false)}
                context={context}
            />
        </>
    );
};

export default AskModal;
